import { ComponentType } from 'react';
import { ProductLegalNoticeProps as addToCartLayerProps } from './product-legal-notice.component';
import dynamic from 'next/dynamic';

const DynamicProductLegalNoticeComponent: ComponentType<addToCartLayerProps> = dynamic(
  () => import('./product-legal-notice.component'),
  {
    ssr: false
  }
);

export default DynamicProductLegalNoticeComponent;
